import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'formatUtcDate',
})
export class FormatUtcDatePipe implements PipeTransform {
  transform(dateTime: string, timezone: string = moment.tz.guess()): string {
    if (!dateTime) return '';
    return moment.tz(dateTime, 'UTC').tz(timezone).format('M/D/YYYY h:mm A');
  }
}
